import { Auth, AuthResponse } from '../../../types/auth';
import { ApiAbstract } from '../abstract';

export class ApiAuth extends ApiAbstract<AuthResponse, Auth> {}
